
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import ImagePreviewAuth from "@/app/ui/components/image-preview-auth/index.vue";
import AuthorizedImage from "@/app/ui/components/authorized-image/index.vue";
import { getToken } from "@/app/infrastructures/misc/Cookies";
import parsingLinkGcpToAws from "@/app/infrastructures/misc/common-library/ParsingLinkGcpToAws";
import needsAuth from "@/app/infrastructures/misc/common-library/NeedsAuth";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ActivityController } from "@/app/ui/controllers/ActivityController";
import { SendActivityApiRequest } from "@/data/payload/api/ActivityApiRequest";

class Props {
  detailData = prop<any>({
    type: Object,
    required: true
  });
}

@Options({
  components: {
    Title,
    ImagePreviewAuth,
    AuthorizedImage
  },
  props: {
    detailData: {
      type: Object,
      required: true
    }
  }
})
export default class DetailContractInformation extends Vue.with(Props) {
  photoPreview = false;
  photo = "";
  onPreviewImage(photo: string) {
    ActivityController.sendActivity(
      new SendActivityApiRequest({
        after: photo,
        before: photo,
        activityHeader: "access-attachment-partner-pos"
      })
    );
    this.photo = photo;
    this.photoPreview = true;
  }

  async onPreviewPdf(url: string) {
    if (!url) return;
    await ActivityController.sendActivity(
      new SendActivityApiRequest({
        after: url,
        before: url,
        activityHeader: "access-attachment-partner-pos"
      })
    );
    try {
      const parsedUrl = parsingLinkGcpToAws(url);
      const init: RequestInit = {};
      if (needsAuth(url)) {
        MainAppController.showLoading();
        const headers = new Headers();
        headers.append("authorization", `Bearer ${getToken()}`);
        init.headers = headers;
      }
      const res = await fetch(parsedUrl, init);
      if (!res.ok) {
        MainAppController.closeLoading();
        throw new Error(`HTTP ${res.status}`);
      }
      const blob = await res.blob();
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      const objUrl = window.URL.createObjectURL(pdfBlob);
      MainAppController.closeLoading();
      window.open(objUrl, "_blank");
      setTimeout(() => URL.revokeObjectURL(objUrl), 60000);
    } catch (e) {
      MainAppController.closeLoading();
      // eslint-disable-next-line no-console
      console.error("Failed to open PDF:", e);
    }
  }

  get photoPreviews() {
    return this.filesView
      ?.filter((e: any) => e.type !== "pdf")
      ?.map((item: any) => ({
        image: item.url,
        url: item.url
      }));
  }

  get filesView() {
    const fileMap = this.detailData.partnerPosAttachFiles.map(
      (item: string) => {
        const formatSplited = item.split(".");
        const isPdf = item.includes("path=pdf");
        return {
          url: item,
          type: isPdf ? "pdf" : formatSplited[formatSplited.length - 1]
        };
      }
    );

    return fileMap;
  }
}
